/**
 * Adds one or more CSS classes to an existing class list, avoiding duplicates.
 *
 * @param {string|string[]} existingClasses - The current CSS class list. Can be a space-separated string or an array of strings.
 * @param {string|string[]} newClasses - The new classes to add. Can be a space-separated string or an array of strings.
 * @param {string} returnFormat - The desired return format. Must be 'string' or 'array'.
 * @returns {string|string[]} The updated class list in the specified format.
 */
export function addUniqueCssClasses(existingClasses, newClasses, returnFormat = 'string') {
   // 1. Normalize existingClasses to an array
   let existingArr = [];
   if (typeof existingClasses === 'string' && existingClasses.length > 0) {
      existingArr = existingClasses.split(' ');
   } else if (Array.isArray(existingClasses)) {
      existingArr = existingClasses;
   }
   
   // 2. Normalize newClasses to an array
   let newArr = [];
   if (typeof newClasses === 'string' && newClasses.length > 0) {
      newArr = newClasses.split(' ');
   } else if (Array.isArray(newClasses)) {
      newArr = newClasses;
   }
   
   // 3. Create a Set to handle uniqueness efficiently
   const classSet = new Set(existingArr);
   
   // 4. Add new classes to the Set, which automatically handles duplicates
   newArr.forEach(cls => {
      classSet.add(cls);
   });
   
   // 5. Convert the Set back to an array
   const finalArr = Array.from(classSet);
   
   // 6. Return the result in the specified format
   if (returnFormat === 'string') {
      return finalArr.join(' ');
   } else if (returnFormat === 'array') {
      return finalArr;
   } else {
      // Handle invalid returnFormat
      console.error("Invalid returnFormat. Please use 'string' or 'array'.");
      return existingClasses; // Return original classes to prevent data loss
   }
}